/**
 * Thrown by SaveSessionCommandHandler when the BE returns 409 from
 * POST /sessions - the plan referenced by the draft was deleted
 * between session start and save. Caller should clear the draft +
 * surface a toast since retry would never succeed.
 */
export class PlanDeletedError extends Error {
  override readonly name: string = 'PlanDeletedError';

  constructor() {
    super('Plan was deleted before session save');
  }
}
